module.exports = {
      id: "parking-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#parking-usage",
      toString: function () {
        return this.url;
      }
    }